/* Next */
import Link from 'next/link'
import { hrefForBrandPath } from 'src/functions/navigationBreadcrumbs'

/* Material */
import Typo from '@mui/material/Typography'

import useStyles from './Brands.styles'

/* Types */
import { tBrands } from 'src/shared/frontendTypes/brand'

const Brands = (props:{brands:tBrands}) => {
  const { brands } = props
  const classes = useStyles()

  const letters = new Array(26).fill(1).map((_, i) => String.fromCharCode( 65 + i ))

  return <div className={classes.brandList}>
    
    {letters.map(letter => (

      brands.some(b=> b.titel.charAt(0).toLocaleUpperCase() === letter) &&

        <div key={letter}>

          <Typo component='h2' variant='h4' color='inherit' gutterBottom>
            {letter}
          </Typo>

          <ul>
            {brands
              .filter(
                b=> b.titel.charAt(0).toLocaleUpperCase() === letter
              )
              .map(brand =>
                <li key={brand.id}>
                  <Link legacyBehavior href={hrefForBrandPath(brand.path, brand.id) || '/brands'}><a>
                    {brand.titel}
                  </a></Link>
                </li>
            )}
          </ul>

        </div>
        
    ))}

  </div>

}

export default Brands
